import React, { useEffect } from 'react';
import './Footer.css';
import { BsFacebook, BsInstagram, BsLinkedin, BsTiktok } from 'react-icons/bs';
import { HiMail, HiPhone, HiLocationMarker } from 'react-icons/hi';
import { Link } from 'react-router-dom';

function Footer() {
  useEffect(() => {
    const target = document.getElementById('ra-verified-seal');
    if (target && !document.getElementById('ra-embed-verified-seal')) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'ra-embed-verified-seal';
      script.src = 'https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js';
      script.setAttribute('data-id', 'ZVJSbWkycFNpR05HcF9HaTpvYmpldGl2YS1zb2x1Y29lcy1lbS1jb25zb3JjaW8=');
      script.setAttribute('data-target', 'ra-verified-seal');
      script.setAttribute('data-model', '2');
      target.appendChild(script);
    }
  }, []);

  const socialLinks = [
    { href: 'https://www.tiktok.com/@objetiva.consorcio', icon: <BsTiktok />, label: 'TikTok' },
    { href: 'https://www.facebook.com/objetivaconsorcio', icon: <BsFacebook />, label: 'Facebook' },
    { href: 'https://www.instagram.com/objetivaconsorcio', icon: <BsInstagram />, label: 'Instagram' },
    { href: 'https://www.linkedin.com/company/objetivaconsorcio', icon: <BsLinkedin />, label: 'LinkedIn' },
  ];

  const ColTitle = ({ children }) => (
    <span className='text-white font-semibold text-xs uppercase tracking-widest pb-2 border-b border-blue-500 block mb-4'>
      {children}
    </span>
  );

  return (
    <div className='w-full flex flex-col'>

      {/* Corpo principal do footer */}
      <div className='w-full py-12 px-6' style={{ backgroundColor: '#004e80' }}>
        <div className='max-w-5xl mx-auto flex h-sm:flex-col gap-10'>

          {/* Coluna 1 — Marca */}
          <div className='flex flex-col flex-1 space-y-4 items-start'>
            <div className='pb-3 border-b w-full' style={{ borderColor: 'rgba(255,255,255,0.15)' }}>
              <img className='h-16 w-auto object-contain' src='objetiva-footer.png' alt='Objetiva Consórcio' />
            </div>
            <p className='text-gray-300 text-sm leading-relaxed'>
              Soluções em consórcio desde 2010. Transparência e segurança em cada negociação.
            </p>
            <div className='flex space-x-4 pt-1'>
              {socialLinks.map(({ href, icon, label }) => (
                <a
                  key={label}
                  href={href}
                  target='_blank'
                  rel='noreferrer'
                  aria-label={label}
                  className='text-gray-300 text-xl hover:text-white transition-colors duration-200'
                >
                  {icon}
                </a>
              ))}
            </div>
            <div className='pt-2'>
              <div id='ra-verified-seal' />
            </div>
          </div>

          {/* Coluna 2 — Empresa */}
          <div className='flex flex-col flex-1'>
            <ColTitle>Empresa</ColTitle>
            <div className='flex flex-col space-y-2'>
              <Link to='/' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className='text-gray-300 text-sm hover:text-white transition-colors duration-200'>Home</Link>
              <Link to='/sobre' className='text-gray-300 text-sm hover:text-white transition-colors duration-200'>Quem somos</Link>
              <Link to='/contato' className='text-gray-300 text-sm hover:text-white transition-colors duration-200'>Contato</Link>
            </div>
          </div>

          {/* Coluna 3 — Serviços */}
          <div className='flex flex-col flex-1'>
            <ColTitle>Serviços</ColTitle>
            <div className='flex flex-col space-y-2'>
              <Link to='/participacaoRemunerada' className='text-gray-300 text-sm hover:text-white transition-colors duration-200'>Parceria remunerada</Link>
              <Link to='/servicos' className='text-gray-300 text-sm hover:text-white transition-colors duration-200'>Intermediação de cotas</Link>
              <Link to='/' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className='text-gray-300 text-sm hover:text-white transition-colors duration-200'>Calculadora</Link>
            </div>
          </div>

          {/* Coluna 4 — Contato */}
          <div className='flex flex-col flex-1'>
            <ColTitle>Contato</ColTitle>
            <div className='flex flex-col space-y-3'>
              <a href='mailto:contato@objetivaconsorcio.com.br' className='flex items-start space-x-2 group'>
                <HiMail className='text-gray-400 text-base flex-shrink-0 mt-0.5 group-hover:text-white transition-colors duration-200' />
                <span className='text-gray-300 text-sm group-hover:text-white transition-colors duration-200'>
                  contato@objetivaconsorcio.com.br
                </span>
              </a>
              <div className='flex items-center space-x-2'>
                <HiPhone className='text-gray-400 text-base flex-shrink-0' />
                <span className='text-gray-300 text-sm'>(11) 3399-5653</span>
              </div>
              <div className='flex items-start space-x-2'>
                <HiLocationMarker className='text-gray-400 text-base flex-shrink-0 mt-0.5' />
                <span className='text-gray-300 text-sm leading-relaxed'>
                  Rua Espírito Santo, 273<br />
                  Aclimação — São Paulo/SP<br />
                  CEP 01526-020
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Barra inferior */}
      <div className='w-full py-4 px-6' style={{ backgroundColor: '#003a60' }}>
        <div className='max-w-5xl mx-auto flex justify-between items-center h-sm:flex-col h-sm:space-y-1 h-sm:text-center'>
          <span className='text-gray-500 text-xs'>
            OBJETIVA — SOLUÇÕES EM CONSÓRCIO S/S LTDA &nbsp;|&nbsp; CNPJ: 13.282.501/0001-50
          </span>
          <div className='flex items-center gap-3'>
            <span className='text-gray-500 text-xs'>
              © {new Date().getFullYear()} Objetiva Consórcio. Todos os direitos reservados.
            </span>
            <span className='text-gray-600 text-xs'>·</span>
            <Link to='/politica-privacidade' className='text-gray-500 text-xs hover:text-gray-300 transition-colors duration-200'>
              Política de Privacidade
            </Link>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Footer;
